import { useRequestPasswordReset } from '@amarantos/api-client'
import { createFileRoute, Link } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthShell } from '@/features/auth/components/auth-shell'
import { ForgotPasswordForm } from '@/features/auth/components/forgot-password-form'
import { toRequestPasswordResetPayload } from '@/features/auth/types/forgot-password-form'

export const Route = createFileRoute('/forgot-password')({
	component: ForgotPasswordRoute,
})

function BackToLoginLink() {
	const { t } = useTranslation()
	return (
		<div className='text-center text-sm'>
			<Link to='/login' className='text-muted-foreground underline-offset-4 hover:underline'>
				{t('auth.forgot_password.back_to_login')}
			</Link>
		</div>
	)
}

function ForgotPasswordRoute() {
	const { t } = useTranslation()
	const [submitted, setSubmitted] = useState(false)
	const requestMutation = useRequestPasswordReset({ mutation: { onSuccess: () => setSubmitted(true) } })

	if (submitted) {
		// Neutral confirmation shown regardless of whether the address exists (anti-enumeration).
		return (
			<AuthShell title={t('auth.forgot_password.sent.title')} description={t('auth.forgot_password.sent.description')}>
				<BackToLoginLink />
			</AuthShell>
		)
	}

	return (
		<AuthShell title={t('auth.forgot_password.title')} description={t('auth.forgot_password.description')}>
			<ForgotPasswordForm
				isSubmitting={requestMutation.isPending}
				onSubmit={async (values) => {
					await requestMutation.mutateAsync({ data: toRequestPasswordResetPayload(values) })
				}}
			/>
			<BackToLoginLink />
		</AuthShell>
	)
}
